import { ProductStartTimeListNode } from "../../../apiHooks";
import { ProductStartPlaceFragment } from "../../../gql-request";
import { ProductContentV2 } from "../../types";
import { ProductLocation } from "../ProductLocation";
import { ProductSectionWrapper, ProductSectionWrapperProps } from "./ProductSectionWrapper";

type ProductLocationSectionProps = Omit<ProductSectionWrapperProps, "children"> & {
    startPlace: {
        geoCoordinate: Omit<ProductStartPlaceFragment["geoCoordinate"], "__typename">;
        googlePlaceId: ProductStartPlaceFragment["googlePlaceId"];
        mapImageUrl: ProductStartPlaceFragment["mapImageUrl"];
        formattedAddress: ProductStartPlaceFragment["formattedAddress"];
    };
    startTimes?: ProductStartTimeListNode[];
    content: ProductContentV2 | undefined;
};
export const ProductLocationSection = ({ startPlace, startTimes, content, ...props }: ProductLocationSectionProps) => {
    const descriptionList = content?.other.get("MEETING_POINT")?.map((x) => x.descriptionJson) ?? [];

    return (
        <ProductSectionWrapper {...props} data-testid="product-location-section">
            <ProductLocation startPlace={startPlace} startTimes={startTimes} descriptionList={descriptionList} />
        </ProductSectionWrapper>
    );
};
